import { useStorage } from "../../contexts/storage";
import { formatStorageValueFromMB } from "../../shared/storageUtils";
import { dotColors } from "../../shared/styles";

const DetailStorage: React.FC = () => {
    const { detalhes } = useStorage();
    
    return(
    <div className="storage-legend mt-4">
        <h5 className="mb-3">Detalhes de armazenamento</h5>
        {detalhes?.map((item, index) => (
            <div key={index} className="legend-item d-flex align-items-center mb-2">
                <div 
                    className="legend-dot" 
                    style={{ 
                        width: '12px', 
                        height: '12px', 
                        borderRadius: '50%', 
                        marginRight: '8px',
                        backgroundColor: dotColors[index % dotColors.length] 
                    }}
                ></div>
                <span className="legend-name flex-grow-1">{item.nome}</span>
                <span className="legend-size text-muted">{formatStorageValueFromMB(item.tamanhoEmMB)}</span>
            </div>
        ))}
    </div>
    );
    }

    
export default DetailStorage;
